import React from 'react'
import MyPayroll from './MyPayroll'


export default function SudentSMSReport() {
  return (
    <div>
      <MyPayroll />
    </div>
  )
}
